import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { OrderPickNewParams } from '../order-pick-new.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';

@Component({
    selector: 'tt-order-pick-new-view',
    templateUrl: './order-pick-new-view.component.html',
    styleUrls: ['./order-pick-new-view.component.css'],
})
export class OrderPickNewViewComponent {
    public params: OrderPickNewParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as OrderPickNewParams;
    }

    onSubmit(event: ErrorMessageResponse) {
        if (window.location.hash.includes('ispopup')) {
            window.opener.postMessage('popupClosed');
            setTimeout(() => window.close(), 0);
        } else {
            this.state.back();
        }
    }
}
